import { AnimatePresence, motion } from "framer-motion";
import { FC, useEffect, useState } from "react";

import { SheetClose } from "~/components/ui/sheet";
import { useFontStyle } from "~/hook/useFontStyle";
import useAuthRoute from "~/hook/useAuthRoute";
import { getSession } from "~/lib/helperFuncation/sessionStorageService";
import { listItemVariants, touchVariants } from "~/lib/motion-obj";
import { cn } from "~/lib/utils";
import { SELECTED_ITEM } from "~/utils/constant";
import { PropsType } from "./type";
import { wantsMobile } from "~/utils/helper-funcations";

const TextItemView: FC<PropsType> = ({ data, category_name }) => {
  const [selectedList, setSelectedList] = useState<number | null>(Number(getSession(SELECTED_ITEM)) || null);
  // const { LocalizedLink } = useLocale();
  const { handleNavigate } = useAuthRoute();
  const { medium, regular } = useFontStyle();

  useEffect(() => {
    sessionStorage.setItem(SELECTED_ITEM, JSON.stringify(selectedList));
  }, [selectedList]);

  return (
    <div className="flex flex-col px-5  mb-5">
      {category_name && (
        <div className={cn("-px-2 my-2")}>
          <h2 className={cn("icon_category_type", medium)}>{category_name}</h2>
        </div>
      )}
      <AnimatePresence>
        <div>
          {data.map((item, index) => {
            const isVisible = wantsMobile(item.show_menu);
            return (
              isVisible && (
                <div
                  key={item.id}
                  onClick={() => handleNavigate(item.navigate_to)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleNavigate(item.navigate_to);
                    }
                  }}
                >
                  <SheetClose
                    className={cn("w-full flex items-center gap-x-2 px-1 py-2 rounded-md ", selectedList === item.id && " bg-secondaryColor")}
                  >
                    <motion.div onClick={() => setSelectedList(item.id)} variants={touchVariants} initial="initial" whileTap="tap">
                      <motion.div
                        className="flex gap-x-2 items-center"
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        variants={listItemVariants}
                        transition={{
                          duration: 0.3,
                          delay: index * 0.1,
                        }}
                      >
                        <p className={cn("icon_category_name  !text-start", regular, selectedList === item.id ? "text-jetBlack" : "")}>{item.name}</p>
                      </motion.div>
                    </motion.div>
                  </SheetClose>
                </div>
              )
            );
          })}
        </div>
      </AnimatePresence>
    </div>
  );
};

export default TextItemView;
